import { Theme } from "../../../../../components/constants";

export default {

    headingContainer: {
        marginBottom: "0px"
    },

    subTextContainer: {
        display: "flex",
        alignItems: "baseline"
    },

    addUserBtn: {
        fontWeight: "700",
        marginLeft: "8px"
    },

    leftSpacing: {
        marginLeft: "5px",
        cursor: "pointer"
    },

    tableActions: {
        display: "flex",
        alignItems: "end",
        justifyContent: "space-between",
        columnGap: "10px"
    },

    text: {
        fontSize: "14px",
        color: Theme.TEXT_PRIMARY_BLACK
    },

    memberName: {
        margin: "0px 0px 0px 8px",
    },

    searchMemberInput: {
        padding: "0px",
        fontSize: "14px"
    },

    container: {
        padding: "0px 40px 25px 40px",
    },

    checkboxContainer: {
        margin: "auto"
    },

    buttonsContainer: {
        display: "flex",
        justifyContent: "end",
        columnGap: "20px",
        marginTop: "20px"
    },

    button: {
        minWidth: "100px"
    },

    popupStyles: {
        borderRadius: "0px",
        maxWidth: "unset",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
    },

    popupoOverlay: {
        background: "transparent",
        position: "fixed",
        top: "calc(50% + 36px)",
        left: "calc(50% + 40px)",
        transform: "translate(-50%, -50%)",
        transition: "all 0.5s ease-in-out 0s",
        width: "calc(100vw - 78px)",
        height: "calc(100vh - 72px)",
        zIndex: 998,
    },

    popupChildrenStyles: {
        maxHeight: "unset",
        height: "100%",
        overflowY: "auto",
        display: "flex",
    },

    mainContainer: {
        width: "100%",
        padding: "0px 40px",
    }
}